import {$, w} from './constants';

$('#warning').delay(300).fadeIn();


$(function() {
    if (localStorage.getItem('popup_accepted')) {
        $('#warning').remove();
        // console.log('PopUp no se mostrará después de aceptar');
    } else {
      $('#closeThis').click(function() {
        localStorage.setItem('popup_accepted', 'true');
            $('#warning').remove();
            // console.log('Desaparece popUp solo hasta aceptar');
        });
    }
});



// Aviso de Cookies

// $(document).ready(function() {
//     // Variable obtener item localstorage
//     var getWarning = localStorage.getItem('warning');
    
  

//     // Cerrar modal
//     $('#closeThis').click(function(e) {// Botón para Cerrar Modal
//         // $('#warning').fadeOut();
//     }); // Modal escondido
//         // Función Cerrar modal con condición
//         if(getWarning != 'shown' ) {
//             // Aparece PopUp después de 3seg.
//             $('#warning').delay(300).fadeIn();
//             localStorage.setItem('warning','shown');
            
//             // else {
//             // }
//     }
//     else {
//        console.log('ya no debe mostrarse el modal');
//     }


//     // Condición, obten key en localStorage
//     // Cuando sea true
	
//         // alert(getWarning != 'shown');
        
//         // Aparece modal 
// });




// WEBPACK FOOTER //
// ./es6/cookies.js